export const AppRoutes = {
  Home: "/",
  Catalog: "/catalog",
  Delivery: "/delivery",
  Contacts: "/contacts",
  Company: "/company",
  Partners: "/partners",
  Form: "/form",
};
